<div
  class="z-[999] fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-xs p-4"
>
  <div
    *ngIf="!openModalAzienda && !openModalEditMedInfo"
    class="flex flex-col space-y-6 max-w-[1000px] xl:max-w-[1100px] 2xl:max-w-[1200px] 3xl:max-w-[1300px] 4xl:max-w-[1400px] px-[24px] pb-4 bg-white w-full relative rounded-lg text-black"
  >
    <!-- HEADER -->
    <div class="flex items-start justify-between w-full border-b border-gray-200 py-4 ">
      <div>
        <h2 class="text-[1.08rem] font-semibold text-dimot-3">
          {{ farmacoToShowData.businessName }}
        </h2>
        <p class="text-xs xl:text-[0.68rem] text-gray-500">
          Creato il {{ farmacoToShowData.creationDate | customDateFormat }}
        </p>
      </div>

      <!-- Close Button -->
      <button
        (click)="closeModal()"
        class="cursor-pointer text-gray-400 hover:text-gray-600"
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 35 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_2900_16273)">
            <path
              d="M1.5 8C1.5 3.58172 5.08172 0 9.5 0H25.5C29.9183 0 33.5 3.58172 33.5 8V24C33.5 28.4183 29.9183 32 25.5 32H9.5C5.08172 32 1.5 28.4183 1.5 24V8Z"
              fill="white"
              shape-rendering="crispEdges"
            />
            <path
              d="M27.0298 24.4698C27.1035 24.5385 27.1626 24.6213 27.2036 24.7133C27.2446 24.8053 27.2667 24.9046 27.2684 25.0053C27.2702 25.106 27.2517 25.2061 27.214 25.2994C27.1762 25.3928 27.1201 25.4777 27.0489 25.5489C26.9777 25.6201 26.8928 25.6762 26.7994 25.714C26.7061 25.7517 26.606 25.7702 26.5053 25.7684C26.4046 25.7667 26.3053 25.7446 26.2133 25.7036C26.1213 25.6626 26.0385 25.6035 25.9698 25.5298L17.4998 17.0611L9.02985 25.5298C8.88767 25.6623 8.69963 25.7345 8.50532 25.731C8.31102 25.7276 8.12564 25.6489 7.98822 25.5115C7.85081 25.3741 7.7721 25.1887 7.76867 24.9944C7.76524 24.8001 7.83737 24.612 7.96985 24.4698L16.4386 15.9998L7.96985 7.52985C7.83737 7.38767 7.76524 7.19963 7.76867 7.00532C7.7721 6.81102 7.85081 6.62564 7.98822 6.48822C8.12564 6.35081 8.31102 6.2721 8.50532 6.26867C8.69963 6.26524 8.88767 6.33737 9.02985 6.46985L17.4998 14.9386L25.9698 6.46985C26.112 6.33737 26.3001 6.26524 26.4944 6.26867C26.6887 6.2721 26.8741 6.35081 27.0115 6.48822C27.1489 6.62564 27.2276 6.81102 27.231 7.00532C27.2345 7.19963 27.1623 7.38767 27.0298 7.52985L18.5611 15.9998L27.0298 24.4698Z"
              fill="#141F58"
            />
          </g>
        </svg>
      </button>
    </div>

    <!-- container two columns -->
    <div class="flex flex-row gap-6 w-full pt-4 pb-4">
      <!-- MAIN LEFT COLUMN -->
      <div class="w-1/2 border-r-1 border-gray-300 pr-10">
        <div class="flex items-start justify-between">
          <div class="flex flex-col gap-2">
            <h3 class="text-[1.08rem] font-semibold text-dimot-3 pr-6">
              Informazioni Prodotto
            </h3>
            <span class="col-span-2 text-gray-500 text-[0.7rem]">
              Dettagli e caratteristiche principali.
            </span>
          </div>

          <!-- edit Button for Informazioni Prodotto -->
          <div class="flex items-start">
            <button
              *ngIf="userCanEdit"
              (click)="editMedicineInfo(true)"
              class="cursor-pointer text-gray-400 hover:text-gray-600"
              aria-label="Modifica informazioni prodotto"
            >
              <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_2964_22143)">
                  <mask id="path-1-inside-1_2964_22143" fill="white">
                    <path d="M1 8C1 3.58172 4.58172 0 9 0H25C29.4183 0 33 3.58172 33 8V24C33 28.4183 29.4183 32 25 32H9C4.58172 32 1 28.4183 1 24V8Z"/>
                  </mask>
                  <path d="M1 8C1 3.58172 4.58172 0 9 0H25C29.4183 0 33 3.58172 33 8V24C33 28.4183 29.4183 32 25 32H9C4.58172 32 1 28.4183 1 24V8Z" fill="white" shape-rendering="crispEdges"/>
                  <path d="M9 0V1H25V0V-1H9V0ZM33 8H32V24H33H34V8H33ZM25 32V31H9V32V33H25V32ZM1 24H2V8H1H0V24H1ZM9 32V31C5.13401 31 2 27.866 2 24H1H0C0 28.9706 4.02944 33 9 33V32ZM33 24H32C32 27.866 28.866 31 25 31V32V33C29.9706 33 34 28.9706 34 24H33ZM25 0V1C28.866 1 32 4.13401 32 8H33H34C34 3.02944 29.9706 -1 25 -1V0ZM9 0V-1C4.02944 -1 0 3.02944 0 8H1H2C2 4.13401 5.13401 1 9 1V0Z" fill="#141F58" mask="url(#path-1-inside-1_2964_22143)"/>
                  <path d="M22.3539 13.0896L19.9099 10.6457C19.8388 10.5746 19.7544 10.5182 19.6615 10.4797C19.5686 10.4412 19.4691 10.4214 19.3685 10.4214C19.268 10.4214 19.1684 10.4412 19.0755 10.4797C18.9826 10.5182 18.8982 10.5746 18.8271 10.6457L12.0836 17.3897C12.0124 17.4607 11.9559 17.5451 11.9174 17.638C11.8789 17.7309 11.8592 17.8306 11.8594 17.9311V20.3751C11.8594 20.5782 11.94 20.7729 12.0836 20.9165C12.2272 21.0601 12.4219 21.1407 12.625 21.1407H15.069C15.1696 21.1409 15.2692 21.1212 15.3621 21.0827C15.455 21.0442 15.5394 20.9878 15.6104 20.9165L22.3539 14.1725C22.425 14.1014 22.4814 14.017 22.5199 13.9241C22.5584 13.8312 22.5782 13.7316 22.5782 13.6311C22.5782 13.5305 22.5584 13.4309 22.5199 13.338C22.4814 13.2451 22.425 13.1607 22.3539 13.0896ZM15.1461 20.4522C15.1257 20.4728 15.0979 20.4844 15.069 20.4845H12.625C12.596 20.4845 12.5682 20.473 12.5477 20.4525C12.5271 20.4319 12.5156 20.4041 12.5156 20.3751V17.9311C12.5157 17.9022 12.5274 17.8744 12.5479 17.854L17.4375 12.9639L20.0357 15.5626L15.1461 20.4522ZM21.8896 13.7087L20.5 15.0983L17.9018 12.5001L19.2914 11.11C19.3016 11.0998 19.3136 11.0917 19.3269 11.0862C19.3402 11.0807 19.3544 11.0779 19.3688 11.0779C19.3832 11.0779 19.3974 11.0807 19.4107 11.0862C19.424 11.0917 19.436 11.0998 19.4462 11.11L21.8896 13.5539C21.8998 13.5641 21.9078 13.5762 21.9134 13.5894C21.9189 13.6027 21.9217 13.617 21.9217 13.6313C21.9217 13.6457 21.9189 13.6599 21.9134 13.6732C21.9078 13.6865 21.8998 13.6985 21.8896 13.7087Z" fill="#141F58"/>
                </g>
              </svg>
            </button>
          </div>
        </div>

        <!-- grid info -->
        <div class="grid grid-cols-2 gap-6 mt-10">
          <!-- left column -->
      <div class="flex flex-col gap-4">
  <div>
    <h3 class="text-gray-600 block text-[0.85rem] mb-1">Principio attivo:</h3>
    <h5 class="text-[0.75rem] text-gray-600">
      {{ farmacoToShowData.activeSubstance }}
    </h5>
  </div>
  <div>
    <h3 class="text-gray-600 block text-[0.85rem] mb-1">Classe di rimborsabilità:</h3>
    <h5 class="text-[0.75rem] text-gray-600">
      {{ farmacoToShowData.reimbursementClass }}
    </h5>
  </div>
  <div>
    <h3 class="text-gray-600 block text-[0.85rem] mb-1">ATC:</h3>
    <h5 class="text-[0.75rem] text-gray-600">
      {{ farmacoToShowData.atc }}
    </h5>
  </div>
</div>

<!-- right column -->
<div class="flex flex-col gap-4">
  <div>
    <h3 class="text-gray-600 block text-[0.85rem] mb-1">Area Terapeutica:</h3>
    <h5 class="text-[0.75rem] text-gray-600">
      {{ farmacoToShowData.therapeuticArea }}
    </h5>
  </div>
  <div>
    <h3 class="text-gray-600 block text-[0.85rem] mb-1">Classe di fornitura:</h3>
    <h5 class="text-[0.75rem] text-gray-600">
      {{ farmacoToShowData.supplyClass }}
    </h5>
  </div>
  <div>
    <h3 class="text-gray-600 block text-[0.85rem] mb-1">AIC:</h3>
    <h5 class="text-[0.75rem] text-gray-600">
      {{ farmacoToShowData.aic }}
    </h5>
  </div>
</div>

<!-- Indicazione terapeutica -->
<div class="col-span-2 mt-4">
  <h3 class="text-gray-600 block text-[0.85rem] mb-1">Indicazione Terapeutica:</h3>
  <h5 class="text-[0.71rem] text-gray-600">
    {{ farmacoToShowData.therapeuticIndication }}
  </h5>
</div>

        </div>
      </div>

    <!-- MAIN RIGHT COLUMN -->
<div class="w-1/2 pl-3">
  <div class="flex items-start justify-between">
    <div>
      <h3 class="text-[1.08rem] font-semibold text-dimot-3 mb-2">
        Personalizza il tuo prodotto
      </h3>
      <p class="text-gray-500 text-[0.7rem] leading-snug">
        Carica logo, scegli font e colori: queste informazioni
      </p>
      <p class="text-gray-500 text-[0.7rem] leading-snug">
        verranno usate per personalizzare report e documenti.
      </p>
    </div>

    <!-- button to openazienda -->
    <div class="flex items-start">
      <button
        *ngIf="userCanEdit"
        (click)="openAzienda()"
        class="cursor-pointer text-gray-400 hover:text-gray-600"
        aria-label="Modifica azienda"
      >
        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_2964_22143)">
            <mask id="path-1-inside-1_2964_22143" fill="white">
              <path d="M1 8C1 3.58172 4.58172 0 9 0H25C29.4183 0 33 3.58172 33 8V24C33 28.4183 29.4183 32 25 32H9C4.58172 32 1 28.4183 1 24V8Z"/>
            </mask>
            <path d="M1 8C1 3.58172 4.58172 0 9 0H25C29.4183 0 33 3.58172 33 8V24C33 28.4183 29.4183 32 25 32H9C4.58172 32 1 28.4183 1 24V8Z" fill="white" shape-rendering="crispEdges"/>
            <path d="M9 0V1H25V0V-1H9V0ZM33 8H32V24H33H34V8H33ZM25 32V31H9V32V33H25V32ZM1 24H2V8H1H0V24H1ZM9 32V31C5.13401 31 2 27.866 2 24H1H0C0 28.9706 4.02944 33 9 33V32ZM33 24H32C32 27.866 28.866 31 25 31V32V33C29.9706 33 34 28.9706 34 24H33ZM25 0V1C28.866 1 32 4.13401 32 8H33H34C34 3.02944 29.9706 -1 25 -1V0ZM9 0V-1C4.02944 -1 0 3.02944 0 8H1H2C2 4.13401 5.13401 1 9 1V0Z" fill="#141F58" mask="url(#path-1-inside-1_2964_22143)"/>
            <path d="M22.3539 13.0896L19.9099 10.6457C19.8388 10.5746 19.7544 10.5182 19.6615 10.4797C19.5686 10.4412 19.4691 10.4214 19.3685 10.4214C19.268 10.4214 19.1684 10.4412 19.0755 10.4797C18.9826 10.5182 18.8982 10.5746 18.8271 10.6457L12.0836 17.3897C12.0124 17.4607 11.9559 17.5451 11.9174 17.638C11.8789 17.7309 11.8592 17.8306 11.8594 17.9311V20.3751C11.8594 20.5782 11.94 20.7729 12.0836 20.9165C12.2272 21.0601 12.4219 21.1407 12.625 21.1407H15.069C15.1696 21.1409 15.2692 21.1212 15.3621 21.0827C15.455 21.0442 15.5394 20.9878 15.6104 20.9165L22.3539 14.1725C22.425 14.1014 22.4814 14.017 22.5199 13.9241C22.5584 13.8312 22.5782 13.7316 22.5782 13.6311C22.5782 13.5305 22.5584 13.4309 22.5199 13.338C22.4814 13.2451 22.425 13.1607 22.3539 13.0896ZM15.1461 20.4522C15.1257 20.4728 15.0979 20.4844 15.069 20.4845H12.625C12.596 20.4845 12.5682 20.473 12.5477 20.4525C12.5271 20.4319 12.5156 20.4041 12.5156 20.3751V17.9311C12.5157 17.9022 12.5274 17.8744 12.5479 17.854L17.4375 12.9639L20.0357 15.5626L15.1461 20.4522ZM21.8896 13.7087L20.5 15.0983L17.9018 12.5001L19.2914 11.11C19.3016 11.0998 19.3136 11.0917 19.3269 11.0862C19.3402 11.0807 19.3544 11.0779 19.3688 11.0779C19.3832 11.0779 19.3974 11.0807 19.4107 11.0862C19.424 11.0917 19.436 11.0998 19.4462 11.11L21.8896 13.5539C21.8998 13.5641 21.9078 13.5762 21.9134 13.5894C21.9189 13.6027 21.9217 13.617 21.9217 13.6313C21.9217 13.6457 21.9189 13.6599 21.9134 13.6732C21.9078 13.6865 21.8998 13.6985 21.8896 13.7087Z" fill="#141F58"/>
          </g>
        </svg>
      </button>
    </div>
  </div>

  <div class="mt-10 grid grid-cols-3 -mx-4 px-4">
    <!-- Logo -->
    <div class="flex flex-col">
      <h2 class="text-[1.1rem] mb-4 text-dimot-3">Logo</h2>
      <div>
        <div
          *ngIf="farmacoToShowData.medicineBrandInfo.logo.url"
          class="w-[80px] h-[80px] bg-gray-50 rounded-full flex justify-center items-center mt-[7px]"
        >
          <img 
            src="{{ farmacoToShowData.medicineBrandInfo.logo.url }}"
            alt="Logo azienda"
          />
        </div>
        <div 
          class="w-[128px] h-[128px] bg-gray-50 rounded-full flex justify-center items-center mt-[7px]"
          *ngIf="!farmacoToShowData.medicineBrandInfo.logo.url">
          <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32.4824 7.03198C27.401 7.03198 22.4336 8.53881 18.2085 11.3619C13.9834 14.185 10.6904 18.1976 8.74577 22.8923C6.80117 27.587 6.29238 32.7528 7.28372 37.7367C8.27507 42.7205 10.722 47.2984 14.3152 50.8916C17.9083 54.4847 22.4863 56.9317 27.4701 57.923C32.4539 58.9144 37.6198 58.4056 42.3145 56.461C47.0091 54.5164 51.0217 51.2233 53.8449 46.9982C56.668 42.7732 58.1748 37.8058 58.1748 32.7243C58.1668 25.9128 55.4574 19.3825 50.6408 14.5659C45.8243 9.74942 39.294 7.03998 32.4824 7.03198ZM18.2358 50.3563C19.7138 47.8986 21.8025 45.865 24.2989 44.4533C26.7953 43.0415 29.6145 42.2996 32.4824 42.2996C35.3504 42.2996 38.1695 43.0415 40.6659 44.4533C43.1623 45.865 45.2511 47.8986 46.7291 50.3563C42.6998 53.6237 37.6699 55.4068 32.4824 55.4068C27.2949 55.4068 22.265 53.6237 18.2358 50.3563ZM23.9183 30.7093C23.9183 29.0154 24.4206 27.3596 25.3616 25.9513C26.3027 24.5429 27.6402 23.4452 29.2051 22.797C30.77 22.1488 32.4919 21.9792 34.1532 22.3097C35.8145 22.6401 37.3405 23.4558 38.5382 24.6535C39.7359 25.8512 40.5515 27.3772 40.882 29.0385C41.2124 30.6998 41.0428 32.4217 40.3946 33.9866C39.7464 35.5515 38.6488 36.889 37.2404 37.8301C35.832 38.7711 34.1762 39.2734 32.4824 39.2734C30.2111 39.2734 28.0328 38.3711 26.4267 36.765C24.8206 35.1589 23.9183 32.9806 23.9183 30.7093ZM48.9835 48.2506C46.6089 44.5583 43.0595 41.7738 38.908 40.3464C40.9781 38.9676 42.5496 36.9593 43.3901 34.6184C44.2306 32.2775 44.2955 29.7283 43.5752 27.3476C42.855 24.967 41.3878 22.8813 39.3906 21.3989C37.3934 19.9165 34.9722 19.1162 32.4849 19.1162C29.9977 19.1162 27.5765 19.1165 25.5793 21.3989C23.5821 22.8813 22.1149 24.967 21.3946 27.3476C20.6744 29.7283 20.7393 32.2775 21.5798 34.6184C22.4203 36.9593 23.9918 38.9676 26.0618 40.3464C21.9104 41.7738 18.361 44.5583 15.9864 48.2506C12.9507 45.0292 10.9246 40.9895 10.1579 36.6301C9.39116 32.2706 9.91748 27.7821 11.6719 23.7182C13.4263 19.6544 16.332 16.1931 20.0305 13.7613C23.729 11.3295 28.0586 10.0337 32.4849 10.0337C36.9113 10.0337 41.2408 11.3295 44.9394 13.7613C48.6379 16.1931 51.5436 19.6544 53.298 23.7182C55.0524 27.7821 55.5787 32.2706 54.812 36.6301C54.0453 40.9895 52.0191 45.0292 48.9835 48.2506Z" fill="#6A7282"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- Font -->
    <div class="relative left-2">
      <h2 class="text-[1.1rem] mb-4 text-dimot-3">Font</h2>
      <ul class="mt-2 text-gray-700 pt-2 flex flex-col gap-4">
        <li class="text-[0.8rem] text-dimot-1">
          <h2 class="mb-2">Titoli</h2>
          <span class="text-[0.7rem] text-gray-600">{{
            farmacoToShowData.medicineBrandInfo.font.title
          }}</span>
        </li>
        <li class="text-[0.8rem] text-dimot-1 mt-2">
          <h2 class="mb-2">Testi</h2>
          <span class="text-[0.7rem] text-gray-600">{{
            farmacoToShowData.medicineBrandInfo.font.subtitle
          }}</span>
        </li>
      </ul>
    </div>

    <!-- Colori -->
    <div class="w-full">
      <h2 class="text-[1.1rem] mb-[23px] text-dimot-3">Colori</h2>
      <ul class="space-y-5 w-full ">
        
        <!-- TITOLI -->
        <li class="w-full">
          <h2 class="text-dimot-3 text-[0.8rem] block mb-1">Titoli</h2>
          <div class="flex max-w-[110px] xl:max-w-[120px] 2xl:max-w-[130px] 3xl:max-w-[150px]">
            <div
              [style.background-color]="farmacoToShowData.medicineBrandInfo.colors.title"
              class="w-[33px] h-[28px] border border-gray-300 rounded-l-lg"
            ></div>
            <div
              class="bg-gray-50 border  border-gray-300 rounded-r px-2 py-1 flex-1 h-[28px] text-[0.6em] flex items-center text-gray-500 min-w-0"
            >
              <span class="truncate">{{ farmacoToShowData.medicineBrandInfo.colors.title }}</span>
            </div>
          </div>
        </li>

        <!-- TESTI -->
        <li class="w-full">
          <h2 class="text-dimot-3 text-[0.8rem] block mb-1">Testi</h2>
          <div class="flex max-w-[110px] xl:max-w-[120px] 2xl:max-w-[130px] 3xl:max-w-[150px]">
            <div
              [style.background-color]="farmacoToShowData.medicineBrandInfo.colors.subtitle"
              class="w-[33px] h-[28px] border border-gray-300 rounded-l-lg"
            ></div>
            <div
              class="bg-gray-50 border border-gray-300 rounded-r px-2 py-1 flex-1 h-[28px] text-[0.6em] flex items-center text-gray-500 min-w-0"
            >
              <span class="truncate">{{ farmacoToShowData.medicineBrandInfo.colors.subtitle }}</span>
            </div>
          </div>
        </li>

        <!-- SFONDO -->
        <li class="w-full">
          <h2 class="text-dimot-3 text-[0.8rem] block mb-1">Sfondo</h2>
          <div class="flex max-w-[110px] xl:max-w-[120px] 2xl:max-w-[130px] 3xl:max-w-[150px]">
            <div
              [style.background-color]="farmacoToShowData.medicineBrandInfo.colors.background"
              class="w-[33px] h-[28px] border border-gray-300 rounded-l-lg"
            ></div>
            <div
              class="bg-gray-50 border border-gray-300 rounded-r px-2 py-1 flex-1 h-[28px] text-[0.6em] flex items-center text-gray-500 min-w-0"
            >
              <span class="truncate">{{ farmacoToShowData.medicineBrandInfo.colors.background }}</span>
            </div>
          </div>
        </li>

      </ul>
    </div>
  </div>
</div>
    </div> <!-- end main two columns -->
  </div> <!-- end modal content -->

  <!-- Modal edit Med information-->
  <ng-container *ngIf="openModalEditMedInfo">
    <app-edit-medicine-information
      [medicineData]="farmacoToShowData"
      (openEditMedInfoModal)="editMedicineInfo($event)"
      (closeEditMedicineInfoEvent)="cancelEditMedicineInfo()"
      (saveChanges)="saveMedicineInfo($event)"
    ></app-edit-medicine-information>
  </ng-container>

  <!-- Modal edit Med colors and font-->
  <ng-container *ngIf="openModalAzienda">
    <app-edit-azienda
      [medicineData]="farmacoToShowData"
      (aziendaModalOpen)="openModalAziendaFromChild($event)"
      (saveChanges)="saveMedicineInfo($event)"
    ></app-edit-azienda>
  </ng-container>
</div>
